import { connectedStore } from '../../store';
import thunks from '../thunks';

const getMediaLibraryAsset = (source) => {
  const store = connectedStore.get();

  return store.dispatch(thunks.getMediaLibraryAsset(source));
};

export default getMediaLibraryAsset;
